/**
 * Generated by orval v6.26.0 🍺
 * Do not edit manually.
 * 爆版PC&开放平台
 * OpenAPI spec version: 1.0.0
 */
import { axiosInstance } from "../../axiosInstance";
export type PostBaobPcSupplyMakePrintSign200Data = {
  app_id: number;
  app_type: number;
  app_url_prefix: string;
  app_user_id: number;
  app_user_name: string;
  sign: string;
  time: number;
};

export type PostBaobPcSupplyMakePrintSign200 = {
  code: number;
  data: PostBaobPcSupplyMakePrintSign200Data;
  msg: string;
};

export type PostBaobPcSupplyMakePrintSignBody = {
  /** 爆版接口前缀 */
  url_prefix?: string;
};

export type ChangeSupplyContractInfoPc200Data = { [key: string]: any };

export type ChangeSupplyContractInfoPc200 = {
  code?: number;
  data?: ChangeSupplyContractInfoPc200Data;
  msg?: string;
};

/**
 * 是否仅校验：0-提交更新，1-仅校验
 */
export type ChangeSupplyContractInfoPcBodyIsCheck =
  (typeof ChangeSupplyContractInfoPcBodyIsCheck)[keyof typeof ChangeSupplyContractInfoPcBodyIsCheck];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ChangeSupplyContractInfoPcBodyIsCheck = {
  NUMBER_0: 0,
  NUMBER_1: 1,
} as const;

export type ChangeSupplyContractInfoPcBody = {
  /** 身份证反面照片(国徽面) */
  back_id_card: string;
  /** 身份证正面照片(人像面) */
  front_id_card: string;
  /** 身份证号 */
  id_card: string;
  /** 是否仅校验：0-提交更新，1-仅校验 */
  is_check?: ChangeSupplyContractInfoPcBodyIsCheck;
  /** 姓名 */
  name: string;
};

export type PostBaobPcSupplyGetSupplyInfo200Data = {
  cats_name: string;
  /** #5146 */
  is_customer_advance_list: string;
  supply_id: string;
};

export type PostBaobPcSupplyGetSupplyInfo200 = {
  code: number;
  data: PostBaobPcSupplyGetSupplyInfo200Data;
  msg: string;
};

export type PostBaobPcSupplyGetSupplyInfoBody = {
  sign?: string;
  timestamp?: string;
};

export type PostBaobPcSupplyGetMessagePopup200DataPerformanceData = {
  /** 开单24H履约率文案 */
  billing_performance_desc: string;
  /** 开单24H履约率的值 */
  billing_performance_rate_text: string;
};

export type PostBaobPcSupplyGetMessagePopup200DataListItemDataDescItem = {
  /** 颜色 */
  bold: number;
  /** 文本 */
  color: string;
  text: string;
};

export type PostBaobPcSupplyGetMessagePopup200DataListItemData = {
  desc: PostBaobPcSupplyGetMessagePopup200DataListItemDataDescItem[];
  /** 标题 */
  text: string;
  /** 类型 0、常规 1、关店 2、降流 3、缓刑 4、关店恢复 */
  type: number;
};

export type PostBaobPcSupplyGetMessagePopup200DataListItem = {
  data?: PostBaobPcSupplyGetMessagePopup200DataListItemData;
  /** 履约提示：shop_performance */
  type: string;
};

export type PostBaobPcSupplyGetMessagePopup200Data = {
  list: PostBaobPcSupplyGetMessagePopup200DataListItem[];
  performance_data: PostBaobPcSupplyGetMessagePopup200DataPerformanceData;
};

export type PostBaobPcSupplyGetMessagePopup200 = {
  code: number;
  data: PostBaobPcSupplyGetMessagePopup200Data;
  /** 是否加粗 0、否 1、是 */
  msg: string;
};

export type PostBaobPcSupplyGetMessagePopupBody = {
  supply_id?: string;
};

export type ErrorResponseData = { [key: string]: any };

export interface ErrorResponse {
  code?: number;
  data?: ErrorResponseData;
  /** 错误信息 */
  msg?: string;
}

type SecondParameter<T extends (...args: any) => any> = Parameters<T>[1];

/**
 * @summary 履约提示弹窗
 */
export const postBaobPcSupplyGetMessagePopup = (
  postBaobPcSupplyGetMessagePopupBody: PostBaobPcSupplyGetMessagePopupBody,
  options?: SecondParameter<typeof axiosInstance>,
) => {
  return axiosInstance<PostBaobPcSupplyGetMessagePopup200>(
    {
      url: `/baob/pc.Supply/getMessagePopup`,
      method: "POST",
      headers: { "Content-Type": "multipart/form-data" },
      data: postBaobPcSupplyGetMessagePopupBody,
    },
    options,
  );
};

/**
 * @summary 获取供应商信息-爆版PC
 */
export const postBaobPcSupplyGetSupplyInfo = (
  postBaobPcSupplyGetSupplyInfoBody: PostBaobPcSupplyGetSupplyInfoBody,
  options?: SecondParameter<typeof axiosInstance>,
) => {
  return axiosInstance<PostBaobPcSupplyGetSupplyInfo200>(
    {
      url: `/baob/pc.Supply/getSupplyInfo`,
      method: "POST",
      headers: { "Content-Type": "multipart/form-data" },
      data: postBaobPcSupplyGetSupplyInfoBody,
    },
    options,
  );
};

/**
 * 商家自主修改合同签署信息（姓名、身份证号、身份证正反面照片）。is_check=1 时仅校验不落库。
 * @summary 修改合同签署信息
 */
export const changeSupplyContractInfoPc = (
  changeSupplyContractInfoPcBody: ChangeSupplyContractInfoPcBody,
  options?: SecondParameter<typeof axiosInstance>,
) => {
  return axiosInstance<ChangeSupplyContractInfoPc200>(
    {
      url: `/baob/pc.Supply/changeSupplyContractInfo`,
      method: "POST",
      headers: { "Content-Type": "multipart/form-data" },
      data: changeSupplyContractInfoPcBody,
    },
    options,
  );
};

/**
 * @summary 创建打印签名
 */
export const postBaobPcSupplyMakePrintSign = (
  postBaobPcSupplyMakePrintSignBody: PostBaobPcSupplyMakePrintSignBody,
  options?: SecondParameter<typeof axiosInstance>,
) => {
  return axiosInstance<PostBaobPcSupplyMakePrintSign200>(
    {
      url: `/baob/pc.Supply/makePrintSign`,
      method: "POST",
      headers: { "Content-Type": "multipart/form-data" },
      data: postBaobPcSupplyMakePrintSignBody,
    },
    options,
  );
};

export type PostBaobPcSupplyGetMessagePopupResult = NonNullable<
  Awaited<ReturnType<typeof postBaobPcSupplyGetMessagePopup>>
>;
export type PostBaobPcSupplyGetSupplyInfoResult = NonNullable<
  Awaited<ReturnType<typeof postBaobPcSupplyGetSupplyInfo>>
>;
export type ChangeSupplyContractInfoPcResult = NonNullable<
  Awaited<ReturnType<typeof changeSupplyContractInfoPc>>
>;
export type PostBaobPcSupplyMakePrintSignResult = NonNullable<
  Awaited<ReturnType<typeof postBaobPcSupplyMakePrintSign>>
>;
